export async function ensurePdfPolyfills(): Promise<void> {
  if (globalThis.Buffer) return;

  const { Buffer } = await import('buffer');
  globalThis.Buffer = Buffer;
}
